import React, { useRef } from 'react';
import cx from 'classnames';
import { useWidthResizableField } from '../../../hook/useWidthResizableField';
import { getLayoutOptionsClass } from '../elements-settings/components/layout-options-setting';

export const CheckboxElement = function FromElement({ element, innerElemHeight, setPosition }) {
  const { options } = element;
  const { alignment } = options ?? {};
  const fieldRef = useRef();

  // Mirrors the field as it is filled in: with no group label of its own the
  // required mark rides the last option instead of a blank line above the
  // field, so the canvas draws the field where the form will draw it. See
  // `init-form/elements/checkbox/index.jsx`.
  const isRequired = !!options.requiredFor;
  const hasGroupLabel = !!String(options.label ?? '').trim();
  const markRidesOption = isRequired && !hasGroupLabel && element.inputs.length > 0;

  useWidthResizableField(fieldRef, element, setPosition);

  return (
    <div ref={fieldRef} className={'element-wrapper'}>
      <div className="element-inner">
        <label htmlFor={element.id} className="form-label w-full">
          {element.options.label} <span className="required">{isRequired && !markRidesOption ? '*' : ''}</span>
        </label>
        <div className={cx('form-control-checkbox-wrapper', getLayoutOptionsClass(options))}>
          {element.inputs.map((option, index) => (
            <div
              key={option.id}
              className={cx('form-control-checkbox', {
                [`form-control-checkbox-${element.options.size}`]: element.options.size,
                [alignment]: alignment,
              })}
            >
              <input name={element.options.label} type="checkbox" value={option.id} />
              <span style={{ fontFamily: 'Arial' }}>
                {option.label}
                {markRidesOption && index === element.inputs.length - 1 && <span className="required">*</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
